module.exports = __webpack_public_path__ + "static/galaxy-spas-10d58cea7673dcc97e64fd32e4b0b2a8.png";